import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const GridWrapper = styled.div`
    height: 20vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 20vh;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        // padding-bottom: 5px;
        background-color: rgb(19, 51, 102);
        color: #fff;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        font-size: 12px;
        // line-height: 30px;
    }

    .donor-connect-user-case-load {s
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-connect-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-connect-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-connect-drop-down > .ag-react-container {
        width: 100%;
    }

    .ag-body-viewport {
        border-left: 1px solid rgb(204, 204, 204);
        border-right: 1px solid rgb(204, 204, 204);
        border-bottom: 1px solid rgb(204, 204, 204);
    }

    .customHeaderLabel {
        font-size: 12px;
    }

    .list-cell-left {
        display: flex;
        justify-content: flex-start;
        width: 100%;
    }
`;

export const TableWrapper = styled(Table)`
    .value-column {
        text-align: center;
    }
`;